import { isServiceUnavailableResult } from "./apiAvailability";

const ERROR_CODE_KEYS = {
  BOT_BLOCKED: "signup_page.access_denied_desc",
  UNAUTHORIZED: "signup_page.unauthorized",
  GETTING_DASHBOARD_REVIEWS_FAILED: "common.general_error",
  GETTING_DASHBOARD_HIGHLIGHTS_FAILED: "common.general_error",
};

export function resolveApiErrorMessage(res, t, fallbackKey = "common.general_error") {
  // Outages (5xx / network failure) would otherwise surface as "HTTP 503".
  if (isServiceUnavailableResult(res)) {
    return typeof t === "function"
      ? t("service_unavailable.title", "Service temporarily unavailable")
      : "Service temporarily unavailable";
  }
  const raw = res?.error ?? res?.message ?? res?.code;
  if (raw == null || raw === "") {
    return typeof t === "function" ? t(fallbackKey, "Something went wrong") : "Something went wrong";
  }
  const text = String(raw).trim();
  if (typeof t === "function") {
    const codeKey = ERROR_CODE_KEYS[text];
    if (codeKey) {
      return t(codeKey, text);
    }
  }
  return text;
}

/**
 * Text for DashboardReducer.failureMsg, which BoardError renders as the page
 * error. An outage gets the translated "temporarily unavailable" title
 * instead of "HTTP 503"; any other failure keeps the API's error text (and
 * stays empty when there is none, so no BoardError shows).
 */
export function resolveBoardFailureMsg(res, t) {
  return isServiceUnavailableResult(res) ? resolveApiErrorMessage(res, t) : res?.error;
}
